// Projets (modèle v2). Les invités sont stockés dans members { uid: rôle } et memberIds [uid…] (requêtes).
import {
  addDoc, arrayRemove, arrayUnion, collection, deleteField, doc, onSnapshot, orderBy, query, serverTimestamp,
  updateDoc, where,
} from 'firebase/firestore';
import { db } from './firebase';
import { isInternalRole } from './users';

export const PROJECT_ROLES = { viewer: 'Read', contributor: 'Contribute' };

// Les horodatages serveur pas encore confirmés sont estimés localement (affichage immédiat).
export const docData = d => ({ id: d.id, ...d.data({ serverTimestamps: 'estimate' }) });

// Peut créer et modifier du contenu dans ce projet (mêmes conditions que firestore.rules).
export const canWriteProject = (profile, project) => !!profile && (
  ['contributor', 'admin'].includes(profile.role)
  || (project?.members || {})[profile.uid] === 'contributor'
);

export const canCreateProject = profile => ['contributor', 'admin'].includes(profile?.role);

// Projets visibles par l'utilisateur : tous pour un membre interne, ses projets partagés pour un externe.
export function watchProjects(profile, onChange, onError) {
  const base = collection(db(), 'projects');
  const q = isInternalRole(profile.role)
    ? query(base, orderBy('name'))
    : query(base, where('memberIds', 'array-contains', profile.uid));
  return onSnapshot(q, snap => {
    const projects = snap.docs.map(docData);
    projects.sort((a, b) => a.name.localeCompare(b.name, 'fr'));
    onChange(projects);
  }, onError);
}

export function watchProject(projectId, onChange, onError) {
  return onSnapshot(doc(db(), 'projects', projectId),
    snap => onChange(snap.exists() ? docData(snap) : null), onError);
}

export async function createProject(profile, { name, description = '' }) {
  const ref = await addDoc(collection(db(), 'projects'), {
    name: name.trim(), description: description.trim(), members: {}, memberIds: [],
    createdBy: profile.uid, createdAt: serverTimestamp(), updatedAt: serverTimestamp(),
  });
  return ref.id;
}

export const updateProject = (projectId, { name, description = '' }) =>
  updateDoc(doc(db(), 'projects', projectId), { name: name.trim(), description: description.trim(), updatedAt: serverTimestamp() });

// Ajoute, modifie (role) ou retire (role = null) un invité ; members et memberIds restent cohérents.
export function setProjectMember(projectId, uid, role) {
  const ref = doc(db(), 'projects', projectId);
  return role
    ? updateDoc(ref, { [`members.${uid}`]: role, memberIds: arrayUnion(uid) })
    : updateDoc(ref, { [`members.${uid}`]: deleteField(), memberIds: arrayRemove(uid) });
}
